export const USER_PROFILE_IMAGE_META_PATH_KEY = 'cp_profile_image_path';
export const USER_PROFILE_IMAGE_META_VERSION_KEY = 'cp_profile_image_version';
export const DEFAULT_USER_PROFILE_IMAGE_PATH = '/AppImage/character_2.webp';

export type CustomUserProfileImage = {
  path: string;
  version: number;
};

export type UserProfileImageKind = 'custom' | 'google' | 'default';

export function defaultUserProfileImageSrc(): string {
  return `${process.env.PUBLIC_URL || ''}${DEFAULT_USER_PROFILE_IMAGE_PATH}`;
}

export function readHttpUrl(value: unknown): string | null {
  if (typeof value !== 'string') return null;
  const trimmed = value.trim();
  if (!/^https?:\/\//i.test(trimmed)) return null;
  return trimmed;
}

export function readGoogleAvatarUrlFromMetadata(
  meta: Record<string, unknown> | null | undefined
): string | null {
  if (!meta) return null;
  return readHttpUrl(meta.avatar_url) ?? readHttpUrl(meta.picture);
}

export function readGoogleAvatarUrlFromUser(user: {
  user_metadata?: Record<string, unknown> | null;
  identities?: Array<{ provider?: string; identity_data?: Record<string, unknown> | null }>;
}): string | null {
  const fromMeta = readGoogleAvatarUrlFromMetadata(user.user_metadata ?? undefined);
  if (fromMeta) return fromMeta;
  const google = user.identities?.find((identity) => identity.provider === 'google');
  return readGoogleAvatarUrlFromMetadata(google?.identity_data ?? undefined);
}

export function readCustomUserProfileImage(
  meta: Record<string, unknown> | null | undefined
): CustomUserProfileImage | null {
  if (!meta) return null;
  const rawPath = meta[USER_PROFILE_IMAGE_META_PATH_KEY];
  const path = typeof rawPath === 'string' ? rawPath.trim() : '';
  const rawVersion = meta[USER_PROFILE_IMAGE_META_VERSION_KEY];
  const version = typeof rawVersion === 'number' ? rawVersion : Number(rawVersion);
  if (!path || !Number.isFinite(version) || version <= 0) return null;
  return { path, version };
}

export function userProfileImageCacheVersion(path: string, version: number): string {
  return `${path.trim()}|${version}`;
}

export function resolveUserProfileImageKind(input: {
  custom: CustomUserProfileImage | null;
  googleAvatarUrl: string | null;
}): UserProfileImageKind {
  if (input.custom) return 'custom';
  if (input.googleAvatarUrl) return 'google';
  return 'default';
}
